import React from 'react';
import { odataProvider } from "../dataProviders/odata/odataProvider";

export let globalDataProvider = new odataProvider();
export const setGlobalDataProvider = (dataProvider) => globalDataProvider = dataProvider;

export const ProtonusContext = React.createContext("ProtonusContext");